/**
 * Genera un código de seguridad para el auto-login y auto-registro
 * 
 * Este código se genera a partir de la fecha actual siguiendo la fórmula:
 * (últimos dos dígitos del año + mes + día) * 7 - 128
 * 
 * @returns {string} El código de seguridad generado
 */
export const generateSecurityCode = () => {
  // Obtener la fecha actual

  const codigo = 111;
  
  return codigo;
};
